import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Button, Card, Row, Col, CardHeader, CardBody, Table, Modal, ModalHeader, ModalBody,
    Label, ModalFooter, Form, UncontrolledTooltip, FormGroup, Input
} from "reactstrap";
import {
    getGroups, getUsersGroup, addUserToGroup, deleteUserFromGroup, getSettingsGroup,
    addSettingsGroup, removeSettingsGroup, getImagesGroup, addImagesGroup,
    removeImagesGroup, getSettingsId, updateSettingsGroup, setGroupUserPageInfo, setGroupSettingPageInfo,
    setGroupImagePageInfo, getAllSSOs, addSsoMappingGroup, getSsoMappingsGroup, deleteSsoMappingGroup,
    updateSsoMappingGroup
} from "../../../actions/actionGroup";
import { getAdminUsers } from "../../../actions/actionAdminUser";
import { getImages } from "../../../actions/actionImage";
import { getUrlFilterPolicies } from "../../../actions/actionFilters";
import { renderField, required, number, positive_float, json, renderCheckbox } from "../../../utils/formValidations.js";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import { Field, reduxForm } from "redux-form";
import { withRouter, Link } from "react-router-dom";
import "react-select/dist/react-select.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../../components/Table/Table";
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";
import { api } from '../../../utils/axios';

import _ from "lodash";

const routes = [
    { name: "Home", path: "/userdashboard", isActive: false },
    { name: "Groups", path: "/groups", isActive: false },
    { name: "ViewGroup", path: "/viewgroup", isActive: true },
];

function getSettingDisplayValue(cellInfo, props) {
    let ret = cellInfo.original.value;
    if (cellInfo.original.value_type === "image") {
        ret = props.images.length > 0 && props.images.find(element => element.image_id === cellInfo.original.value)
            ? props.images.find(element => element.image_id === cellInfo.original.value).image_friendly_name : ""
    }
    else if (cellInfo.original.value_type === "filter_policy") {
        ret = props.filters.length > 0 && props.filters.find(element => element.filter_policy_id === cellInfo.original.value)
            ? props.filters.find(element => element.filter_policy_id === cellInfo.original.value).filter_policy_name : ""
    }
    return ret
}

class ViewGroupFormTemplate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentGroup: null,
            userModal: false,
            settingModal: false,
            imageModal: false,
            addUserModal: false,
            addImageModal: false,
            addSettingModal: false,
            updateSettingModal: false,
            groupSettingId: null,
            updateName: null,
            updateType: null,
            updateValue: null,
            userId: null,
            imageId: null,
            groupId: null,
            settingValue: "",
            newValue: "",
            updateUsageInterval: null,
            updateUsageType: null,
            updateUsageHours: null,
            createUsageInterval: "daily",
            createUsageType: "per_user",
            createUsageHours: null,
            addImageId: null,
            addGroupSettingId: null,
            addUserId: null,
            userName: null,
            settings: [],
            users: [],
            images: [],
            adminUsers: [],
            adminUsersFilter: null,
            adminUsersPage: 0,
            ssos: [],
            groupMappings: [],
            updateSsoMappingModal: false,
            deleteSsoMappingModal: false,
            addSsoMappingModal: false

        };

        this.groupsTableRef = React.createRef();

        this.deleteUserGroupConfirm = this.deleteUserGroupConfirm.bind(this);
        this.deleteUserGroup = this.deleteUserGroup.bind(this);
        this.deleteSettingGroupConfirm = this.deleteSettingGroupConfirm.bind(this);
        this.updateSettingGroupConfirm = this.updateSettingGroupConfirm.bind(this);
        this.deleteSettingGroup = this.deleteSettingGroup.bind(this);
        this.deleteImageGroupConfirm = this.deleteImageGroupConfirm.bind(this);
        this.deleteImageGroup = this.deleteImageGroup.bind(this);
        this.addUserToGroup = this.addUserToGroup.bind(this);
        this.addImagesGroup = this.addImagesGroup.bind(this);
        this.addSettingsGroup = this.addSettingsGroup.bind(this);
        this.updateSettingsGroup = this.updateSettingsGroup.bind(this);
        this.openUserAddModal = this.openUserAddModal.bind(this);
        this.openImageAddModal = this.openImageAddModal.bind(this);
        this.openSettingAddModal = this.openSettingAddModal.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleModal2 = this.toggleModal2.bind(this);
        this.deleteImgConfirm = this.deleteImgConfirm.bind(this);
        this.toggleSetting = this.toggleSetting.bind(this);
        this.deleteSetConfirm = this.deleteSetConfirm.bind(this);
        this.openUpdateSettingModal = this.openUpdateSettingModal.bind(this);
        this.toggleImage = this.toggleImage.bind(this);
        this.handleUserDropDown = this.handleUserDropDown.bind(this);
        this.handleImageDropDown = this.handleImageDropDown.bind(this);
        this.handleDefaultImageDropDown = this.handleDefaultImageDropDown.bind(this);
        this.handleDefaultFilterDropDown = this.handleDefaultFilterDropDown.bind(this);
        this.updateDefaultImageDropDown = this.updateDefaultImageDropDown.bind(this);
        this.updateDefaultFilterDropDown = this.updateDefaultFilterDropDown.bind(this);
        this.handleUpdateUsageInterval = this.handleUpdateUsageInterval.bind(this);
        this.handleUpdateUsageType = this.handleUpdateUsageType.bind(this);
        this.handleUpdateUsageHours = this.handleUpdateUsageHours.bind(this);
        this.handleSettingDropDown = this.handleSettingDropDown.bind(this);
        this.handleCreateUsageInterval = this.handleCreateUsageInterval.bind(this);
        this.handleCreateUsageType = this.handleCreateUsageType.bind(this);
        this.handleCreateUsageHours = this.handleCreateUsageHours.bind(this);
        this.handleSettingDropDown = this.handleSettingDropDown.bind(this);
        this.handleAddSettingsGroupSuccess = this.handleAddSettingsGroupSuccess.bind(this);
        this.handleAddSettingsGroupError = this.handleAddSettingsGroupError.bind(this);
        this.handleAddImagesGroupSuccess = this.handleAddImagesGroupSuccess.bind(this);
        this.handleAddImagesGroupError = this.handleAddImagesGroupError.bind(this);
        this.handleAddUserSuccess = this.handleAddUserSuccess.bind(this);
        this.handleAddUserError = this.handleAddUserError.bind(this);
        this.handleDeleteSettingSuccess = this.handleDeleteSettingSuccess.bind(this);
        this.handleDeleteSettingError = this.handleDeleteSettingError.bind(this);
        this.handleDeleteUserSuccess = this.handleDeleteUserSuccess.bind(this);
        this.handleDeleteUserError = this.handleDeleteUserError.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleBlur2 = this.handleBlur2.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.toggleMappingModal = this.toggleMappingModal.bind(this)
        this.toggleDeleteMappingModal = this.toggleDeleteMappingModal.bind(this);
        this.openSsoMappingAddModal = this.openSsoMappingAddModal.bind(this)
        this.openUpdateSsoMappingModal = this.openUpdateSsoMappingModal.bind(this)
        this.addSsoMappingGroup = this.addSsoMappingGroup.bind(this)
        this.updateSsoMappingGroup = this.updateSsoMappingGroup.bind(this)
        this.deleteSsoMappingGroup = this.deleteSsoMappingGroup.bind(this)
        this.handleAddSsoMappingGroupSuccess = this.handleAddSsoMappingGroupSuccess.bind(this)
        this.handleAddSsoMappingGroupError = this.handleAddSsoMappingGroupError.bind(this)
        this.handleUpdateSsoMappingGroupSuccess = this.handleUpdateSsoMappingGroupSuccess.bind(this)
        this.handleUpdateSsoMappingGroupError = this.handleUpdateSsoMappingGroupError.bind(this)
        this.handleDeleteSsoMappingGroupSuccess = this.handleDeleteSsoMappingGroupSuccess.bind(this)
        this.handleDeleteSsoMappingGroupError = this.handleDeleteSsoMappingGroupError.bind(this)
        this.handleSsoDropDown = this.handleSsoDropDown.bind(this)
        this.handleSsoGlobal = this.handleSsoGlobal.bind(this)
        this.handleSsoGroupAttributes = this.handleSsoGroupAttributes.bind(this)
    }

    componentDidMount() {
        this.props.getGroups();
        this.props.getAllSSOs();
        this.props.getUrlFilterPolicies();
        this.props.getUsersGroup(this.props.match.params.id, 0, 5);
        this.props.getSettingsGroup(this.props.match.params.id);
        this.props.getImagesGroup(this.props.match.params.id);
        this.props.getSsoMappingsGroup(this.props.match.params.id);
    }

    deleteUserGroupConfirm(userId, userName) {
        this.setState(
            {
                userModal: !this.state.userModal,
                userId: userId,
                userName: userName
            });
    }

    async deleteUserGroup() {
        try {
            await this.props.deleteUserFromGroup({
                groupId: this.state.currentGroup.group_id,
                userId: this.state.userId,
            });

            await this.handleDeleteUserSuccess();
            await this.groupsTableRef.current.fetch();
        } catch (e) {
            this.handleDeleteUserError();
        }
    }

    deleteSettingGroupConfirm(groupSettingId) {
        this.setState(
            {
                settingModal: !this.state.settingModal,
                groupSettingId: groupSettingId
            });
    }

    updateSettingGroupConfirm(groupSettingId, name, value, type) {
        this.props.initialize({ inputValue: value });
        if (name === "usage_limit") {
            let data = JSON.parse(value);
            this.setState(
                {
                    updateUsageInterval: data.interval,
                    updateUsageType: data.type,
                    updateUsageHours: data.hours
                }
            );
            this.props.initialize({ update_usage_hours: data.hours });

        }
        this.setState(
            {
                updateSettingModal: !this.state.updateSettingModal,
                groupSettingId: groupSettingId,
                updateName: name,
                updateValue: value,
                updateType: type,
                newValue: value,
                radio1: value
            });
    }

    deleteSettingGroup() {
        let data = {};
        data = this.state.groupSettingId;
        this.props.removeSettingsGroup(data).then(() => this.handleDeleteSettingSuccess()).
            catch(() => this.handleDeleteSettingError());
    }

    deleteImageGroupConfirm(imageId) {
        this.setState(
            {
                imageModal: !this.state.imageModal,
                imageId: imageId
            });
    }

    deleteImageGroup() {
        let data = {};
        data.imageId = this.state.imageId;
        data.groupId = this.state.currentGroup.group_id;
        this.props.removeImagesGroup(data).then(() => this.handleDeleteImageSuccess()).
            catch(() => this.handleDeleteImageError());
    }

    handleDeleteImageSuccess() {
        const { errorImageMessage } = this.props;
        if (errorImageMessage) {
            NotificationManager.error(errorImageMessage, "Delete Image From Group", 3000);
        }
        else {
            this.setState({ imageModal: false });
            NotificationManager.success("Successfully Deleted Workspace from Group", "Delete Image From Group", 3000);
            this.props.getGroups();
            this.props.getImagesGroup(this.props.match.params.id);
        }
    }

    handleDeleteImageError() {
        const { removeImagesGroupsError } = this.props;
        if (removeImagesGroupsError) {
            NotificationManager.error(removeImagesGroupsError, "Delete Image From Group", 3000);
        }
        else {
            this.setState({ imageModal: false });
            NotificationManager.error("Error Deleting Workspace from Group", "Delete Image From Group", 3000);
            this.props.getGroups();
            this.props.getImagesGroup(this.props.match.params.id);
        }
    }

    handleDeleteSettingSuccess() {
        const { errorMessageRemove } = this.props;
        if (errorMessageRemove) {
            NotificationManager.error(errorMessageRemove, "Delete Setting To Group", 3000);
            this.props.getGroups();
            this.props.getSettingsGroup(this.props.match.params.id);
        }
        else {
            this.setState({ settingModal: false });
            NotificationManager.success("Successfully Deleted Setting from Group", "Delete Setting From Group", 3000);
            this.props.getGroups();
            this.props.getSettingsGroup(this.props.match.params.id);
        }
    }

    handleDeleteSettingError() {
        const { deleteSettingFomGroupGroupsError } = this.props;
        if (deleteSettingFomGroupGroupsError) {
            NotificationManager.error(deleteSettingFomGroupGroupsError, "Delete Setting From Group", 3000);
            this.props.getGroups();
            this.props.getSettingsGroup(this.props.match.params.id);
        }
        else {
            this.setState({ settingModal: false });
            NotificationManager.error("Error Deleting Setting from Group", "Delete Setting From Group", 3000);
            this.props.getGroups();
            this.props.getSettingsGroup(this.props.match.params.id);
        }
    }


    handleDeleteUserSuccess() {
        const { errorMessageDeleteUser } = this.props;
        if (errorMessageDeleteUser) {
            NotificationManager.error(errorMessageDeleteUser, "Delete User To Group", 3000);
        }
        else {
            this.setState({ userModal: false });
            NotificationManager.success("Successfully Deleted User from Group", "Delete User From Group", 3000);
        }
    }

    handleDeleteUserError() {
        const { deleteUserFomGroupGroupsError } = this.props;
        if (deleteUserFomGroupGroupsError) {
            NotificationManager.error(deleteUserFomGroupGroupsError, "Delete User From Group", 3000);
        }
        else {
            this.setState({ userModal: false });
            NotificationManager.error("Error Deleting User from Group", "Delete User From Group", 3000);
        }
    }

    async addUserToGroup() {
        try {
            await this.props.addUserToGroup({
                userId: this.state.addUserId,
                groupId: this.state.currentGroup.group_id,
            });

            await this.handleAddUserSuccess();

            if (this.groupsTableRef.current) {
                this.groupsTableRef.current.fetch();
            }
        } catch (e) {
            this.handleAddUserError();
        }
    }

    addImagesGroup() {
        let data = {};
        data.imageId = this.state.addImageId;
        data.groupId = this.state.currentGroup.group_id;
        this.props.addImagesGroup(data).then(() => this.handleAddImagesGroupSuccess()).catch(() => this.handleAddImagesGroupError());
    }

    addSettingsGroup() {
        if (this.state.addGroupSettingId == null)
            return
        let data = {};
        data.groupId = this.state.currentGroup.group_id;
        data.groupSettingId = this.state.addGroupSettingId;
        if (this.state.value_type === "usage_limit") {
            let _data = {
                type: this.state.createUsageType,
                hours: parseFloat(this.state.createUsageHours),
                interval: this.state.createUsageInterval
            };
            data.value = JSON.stringify(_data)
        }
        else {
            data.value = this.state.value_type == "bool" ? this.state.radio1 : this.state.settingValue;
        }

        this.props.addSettingsGroup(data).then(() => this.handleAddSettingsGroupSuccess()).catch(() => this.handleAddSettingsGroupError());
    }

    updateSettingsGroup() {
        let data = {};
        data.groupId = this.state.currentGroup.group_id;
        data.groupSettingId = this.state.groupSettingId;
        if (this.state.updateName === "usage_limit") {
            let _data = {
                type: this.state.updateUsageType,
                hours: parseFloat(this.state.updateUsageHours),
                interval: this.state.updateUsageInterval
            };
            data.value = JSON.stringify(_data)
        }
        else {
            data.value = this.state.updateType == "bool" ? this.state.radio1 : this.state.newValue;
        }

        this.props.updateSettingsGroup(data).then(() => this.handleUpdateSettingsGroupSuccess()).catch(() => this.handleUpdateSettingsGroupError());
    } //

    handleUpdateSettingsGroupSuccess() {
        const { updateSettingsGroupErrorMessage } = this.props;
        if (updateSettingsGroupErrorMessage) {
            NotificationManager.error(updateSettingsGroupErrorMessage, "Update Setting To Group", 3000);
            this.setState({ updateSettingModal: false, updateType: "" });
            this.props.getGroups();
            this.props.getSettingsGroup(this.props.match.params.id);
        }
        else {
            this.setState({ updateSettingModal: false, updateType: "" });
            NotificationManager.success("Setting Updated to group successfully", "Update Setting To Group", 3000);
            this.props.getGroups();
            this.props.getSettingsGroup(this.props.match.params.id);
            this.props.initialize({ value: "" });
        }
    }

    handleUpdateSettingsGroupError() {
        const { updateSettingsGroupsError } = this.props;
        if (updateSettingsGroupsError) {
            NotificationManager.error(updateSettingsGroupsError, "Update Setting To Group", 3000);
        }
        else {
            this.setState({ updateSettingModal: false });
            NotificationManager.error("Error in updating setting to group", "Update Setting To Group", 3000);
            this.props.getGroups();
            this.props.getSettingsGroup(this.props.match.params.id);
        }
    }

    handleAddSettingsGroupSuccess() {
        const { addSettingsGroupErrorMessage } = this.props;
        if (addSettingsGroupErrorMessage) {
            NotificationManager.error(addSettingsGroupErrorMessage, "Add Setting To Group", 3000);
            this.setState({ addSettingModal: false, addGroupSettingId: null, currentGroup: null, value_type: undefined, description: "" });
            this.props.getGroups();
            this.props.getSettingsGroup(this.props.match.params.id);
        }
        else {
            this.setState({ addSettingModal: false, addGroupSettingId: null, currentGroup: null, value_type: undefined, description: "" });
            NotificationManager.success("Setting Added to group successfully", "Add Setting To Group", 3000);
            this.props.getGroups();
            this.props.getSettingsGroup(this.props.match.params.id);
            this.props.initialize({ value: "" });
        }
    }

    handleAddSettingsGroupError() {
        const { addSettingsGroupsError } = this.props;
        if (addSettingsGroupsError) {
            NotificationManager.error(addSettingsGroupsError, "Add Setting To Group", 3000);
        }
        else {
            this.setState({ addSettingModal: false, value_type: "" });
            NotificationManager.error("Error in adding setting to group", "Add Setting To Group", 3000);
            this.props.getGroups();
            this.props.getAllSSOs();
            this.props.getSettingsGroup(this.props.match.params.id);
        }
    }

    handleAddImagesGroupSuccess() {
        const { errorAddImageMessage } = this.props;
        if (errorAddImageMessage) {
            NotificationManager.error(errorAddImageMessage, "Add Workspace To Group", 3000);
        }
        else {
            NotificationManager.success("Successfully Added Workspace to Group", "Add Workspace To Group", 3000);
            this.setState({ addImageModal: false });
            this.props.getGroups();
            this.props.getImagesGroup(this.props.match.params.id);
        }
    }

    handleAddImagesGroupError() {
        const { addImagesGroupsError } = this.props;
        if (addImagesGroupsError) {
            NotificationManager.error(addImagesGroupsError, "Add Workspace To Group", 3000);
        }
        else {
            NotificationManager.error("Error Adding Workspace to Group", "Add Workspace To Group", 3000);
            this.setState({ addImageModal: false });
            this.props.getGroups();
            this.props.getImagesGroup(this.props.match.params.id);
        }
    }

    handleAddUserSuccess() {
        const { errorMessageAddUser } = this.props;
        if (errorMessageAddUser) {
            NotificationManager.error(errorMessageAddUser, "Add User To Group", 3000);
        }
        else {
            this.setState({ addUserModal: false });
            NotificationManager.success("Successfully Added User to Group", "Add User To Group", 3000);
        }
    }

    handleAddUserError() {
        const { addUserToGroupGroupsError } = this.props;
        if (addUserToGroupGroupsError) {
            NotificationManager.error(addUserToGroupGroupsError, "Add User To Group", 3000);
        }
        else {
            this.setState({ addUserModal: false });
            NotificationManager.error("Error Adding User to Group", "Add User To Group", 3000);
        }
    }

    handleUserDropDown(value) {
        if (value) {
            this.setState({
                addUserId: value.user_id,
                adminUsers: []
            });

            this.fetchUserAdmins(0, value.username);
        } else {
            this.setState({
                addUserId: null,
                adminUsers: [],
                adminUsersFilter: null,
                adminUsersPage: 0
            });

            this.fetchUserAdmins(0);
        }
    }

    handleImageDropDown(value) {
        this.setState({ addImageId: value.image_id });
    }

    handleDefaultImageDropDown(value) {
        this.setState({ settingValue: value.image_id });
    }

    handleDefaultFilterDropDown(value) {
        this.setState({ settingValue: value.filter_policy_id });
    }

    updateDefaultImageDropDown(value) {
        this.setState({ newValue: value.image_id });
    }
    updateDefaultFilterDropDown(value) {
        this.setState({ newValue: value.filter_policy_id });
    }
    handleUpdateUsageInterval(value) {
        this.setState({ updateUsageInterval: value.value });
    }
    handleUpdateUsageType(value) {
        this.setState({ updateUsageType: value.value });
    }
    handleUpdateUsageHours(e) {
        this.setState({ updateUsageHours: e.target.value });
    }
    handleCreateUsageInterval(value) {
        this.setState({ createUsageInterval: value.value });
    }
    handleCreateUsageType(value) {
        this.setState({ createUsageType: value.value });
    }
    handleCreateUsageHours(e) {
        this.setState({ createUsageHours: e.target.value });
    }

    handleSettingDropDown(value) {
        this.setState({ addGroupSettingId: value.group_setting_id, value_type: value.value_type, setting_value: value.value, description: value.description });
    }

    handleRadio(e) {
        this.setState({ radio1: e.target.value });
    }

    openUserAddModal() {
        this.setState({
            addUserId: null,
            adminUsers: [],
            adminUsersFilter: null,
            adminUsersPage: 0,
            addUserModal: !this.state.addUserModal
        });

        this.fetchUserAdmins(0);
    }

    openImageAddModal() {
        this.props.getImages();
        this.setState({ addImageModal: !this.state.addImageModal });
    }

    openSettingAddModal() {
        this.props.getSettingsId();
        this.setState({ addSettingModal: !this.state.addSettingModal });
    }

    openUpdateSettingModal() {
        this.setState({ updateSettingModal: !this.state.updateSettingModal });
    }

    toggle() {
        this.setState({ userModal: !this.state.userModal });
    }

    deleteSetConfirm() {
        this.setState({ settingModal: !this.state.settingModal });
    }

    deleteImgConfirm() {
        this.setState({ imageModal: !this.state.imageModal });
    }

    toggleImage() {
        this.setState({ addImageModal: !this.state.addImageModal });
    }

    toggleModal2() {
        this.setState({ addUserModal: !this.state.addUserModal });
    }

    toggleSetting() {
        this.setState({ addSettingModal: !this.state.addSettingModal });
        this.props.initialize({ value: " " });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.groups.length > 0) {
            let currentGroup = nextProps.groups.find(group => group.group_id === this.props.match.params.id);
            this.setState({ currentGroup: currentGroup });
        }
    }

    renderUsers() {
        const columns = [
            {
                type: "text",
                accessor: "name",
                name: "User Name",
                filterable: true,
                sortable: true
            },
        ];

        const actions = [
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "delete":
                    this.deleteUserGroupConfirm(item.user_id, item.name);
                    break;
            }
        }

        const onFetch = async (options) => {
            const data = {
                target_group: {
                    group_id: this.state.currentGroup.group_id
                },
                page: options.page,
                page_size: options.pageSize,
                filters: options.filters,
                sort_by: options.sortBy,
                sort_direction: options.sortDirection
            }

            const { users, page } = await api.post('admin/get_users_group', data);

            return {
                items: users,
                page
            }
        }

        return (
            <div>
                <DataTable
                    ref={this.groupsTableRef}
                    id="group-users"
                    columns={columns}
                    actions={actions}
                    onAction={onAction}
                    onFetch={onFetch}
                />
            </div>
        );
    }

    renderSettings() {
        const columns = [
            {
                type: "text",
                accessor: "name",
                name: "Name",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "description",
                name: "Description",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "value",
                name: "Value",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "value_type",
                name: "Type",
                filterable: true,
                sortable: true
            },
        ];

        const actions = [
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "edit":
                    this.updateSettingGroupConfirm(
                        item.group_setting_id,
                        item.name,
                        item.value,
                        item.value_type
                    );
                    break;

                case "delete":
                    this.deleteSettingGroupConfirm(item.group_setting_id);
                    break;
            }
        }

        return (
            <div>
                <DataTable
                    id="group-settings"
                    data={this.props.settings}
                    columns={columns}
                    actions={actions}
                    onAction={onAction}
                />
            </div>
        );
    }

    renderImages() {
        const columns = [
            {
                type: "text",
                accessor: "image_friendly_name",
                name: "Workspace",
                filterable: true,
                sortable: true
            },
        ];

        const actions = [
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "delete":
                    this.deleteImageGroupConfirm(item.image_id);
                    break;
            }
        }

        return (
            <div>
                <DataTable
                    id="group-images"
                    data={this.props.images}
                    columns={columns}
                    actions={actions}
                    onAction={onAction}
                />
            </div>
        );
    }

    openSsoMappingAddModal() {
        this.props.getAllSSOs();
        this.setState({
            sso_global: false,
            sso_id: null,
            sso_type: null,
            sso_group_attributes: null,
            addSsoMappingModal: !this.state.addSsoMappingModal,
        });
    }

    toggleMappingModal() {
        this.setState({ addSsoMappingModal: !this.state.addSsoMappingModal });
    }

    addSsoMappingGroup() {
        let data = {};
        if (this.state.sso_id === null) {
            NotificationManager.error("An SSO provider must be selected", "Add SSO Mapping To Group", 3000);
            return;
        }

        data.sso_id = this.state.sso_id;
        data.sso_group_attributes = this.state.sso_group_attributes;
        data.apply_to_all_users = this.state.sso_global;
        data.groupId = this.state.currentGroup.group_id;
        this.props.addSsoMappingGroup(data).then(() => this.handleAddSsoMappingGroupSuccess()).catch(() => this.handleAddSsoMappingGroupError());
    }

    handleAddSsoMappingGroupSuccess() {
        const { addSsoMappingMessage } = this.props;
        if (addSsoMappingMessage) {
            NotificationManager.error(addSsoMappingMessage, "Add SSO Mapping To Group", 3000);
        }
        else {
            NotificationManager.success("Successfully Added SSO Mapping to Group", "Add SSO Mapping To Group", 3000);
            this.setState({ addSsoMappingModal: false });
            this.props.getGroups();
            this.props.getAllSSOs();
            this.props.getSsoMappingsGroup(this.props.match.params.id);
        }
    }

    handleAddSsoMappingGroupError() {
        const { addSsoMappingGroupsError } = this.props;
        if (addSsoMappingGroupsError) {
            NotificationManager.error(addSsoMappingGroupsError, "Add SSO To Group Mapping", 3000);
        }
        else {
            NotificationManager.error("Error Adding SSO Mapping to Group", "Add SSO To Group Mapping", 3000);
            this.setState({ addSsoMappingModal: false });
            this.props.getGroups();
            this.props.getAllSSOs();
            this.props.getSsoMappingsGroup(this.props.match.params.id);
        }
    }

    openUpdateSsoMappingModal() {
        this.setState({ updateSsoMappingModal: !this.state.updateSsoMappingModal });
    }

    updateSsoMappingGroupConfirm(sso_group_id, sso_id, sso_type, sso_group_attributes, apply_to_all_users) {
        this.setState(
            {
                updateSsoMappingModal: !this.state.updateSsoMappingModal,
                sso_group_id: sso_group_id,
                sso_id: sso_id,
                sso_type: sso_type,
                sso_group_attributes: sso_group_attributes,
                sso_global: apply_to_all_users,
            });
    }

    updateSsoMappingGroup() {
        let data = {};
        data.sso_group_id = this.state.sso_group_id;
        data.sso_id = this.state.sso_id;
        data.sso_type = this.state.sso_type;
        data.sso_group_attributes = this.state.sso_group_attributes;
        data.apply_to_all_users = this.state.sso_global;

        this.props.updateSsoMappingGroup(data).then(() => this.handleUpdateSsoMappingGroupSuccess()).catch(() => this.handleUpdateSsoMappingGroupError());
    }

    handleUpdateSsoMappingGroupSuccess() {
        const { updateSsoMappingMessage } = this.props;
        if (updateSsoMappingMessage) {
            NotificationManager.error(updateSsoMappingMessage, "Update SSO Group Mapping", 3000);
        }
        else {
            NotificationManager.success("Successfully Updated SSO to Group Mapping", "Update SSO Group Mapping", 3000);
            this.setState({ updateSsoMappingModal: false });
            this.props.getGroups();
            this.props.getAllSSOs();
            this.props.getSsoMappingsGroup(this.props.match.params.id);
        }
    }

    handleUpdateSsoMappingGroupError() {
        const { updateSsoMappingGroupsError } = this.props;
        if (updateSsoMappingGroupsError) {
            NotificationManager.error(updateSsoMappingGroupsError, "Update SSO Group Mapping", 3000);
        }
        else {
            NotificationManager.error("Error Updating SSO to Group Mapping", "Update SSO Group Mapping", 3000);
            this.setState({ updateSsoMappingModal: false });
            this.props.getGroups();
            this.props.getAllSSOs();
            this.props.getSsoMappingsGroup(this.props.match.params.id);
        }
    }

    toggleDeleteMappingModal() {
        this.setState({ deleteSsoMappingModal: !this.state.deleteSsoMappingModal });
    }

    deleteSsoMappingGroupConfirm(ssoGroupId) {
        this.setState(
            {
                deleteSsoMappingModal: !this.state.deleteSsoMappingModal,
                ssoGroupId: ssoGroupId,
            });
    }

    deleteSsoMappingGroup() {
        let data = this.state.ssoGroupId;
        this.props.deleteSsoMappingGroup(data).then(() => this.handleDeleteSsoMappingGroupSuccess()).
            catch(() => this.handleDeleteSsoMappingGroupError());
    }

    handleDeleteSsoMappingGroupSuccess() {
        const { deleteSsoMappingMessage } = this.props;
        if (deleteSsoMappingMessage) {
            NotificationManager.error(deleteSsoMappingMessage, "Delete SSO To Group Mapping", 3000);
        }
        else {
            NotificationManager.success("Successfully Deleted SSO to Group Mapping", "Delete SSO To Group Mapping", 3000);
            this.setState({ deleteSsoMappingModal: false });
            this.props.getGroups();
            this.props.getAllSSOs();
            this.props.getSsoMappingsGroup(this.props.match.params.id);
        }
    }

    handleDeleteSsoMappingGroupError() {
        const { deleteSsoMappingGroupsError } = this.props;
        if (deleteSsoMappingGroupsError) {
            NotificationManager.error(deleteSsoMappingGroupsError, "Delete SSO To Group Mapping", 3000);
        }
        else {
            NotificationManager.error("Error Deleting SSO to Group Mapping", "Delete SSO To Group Mapping", 3000);
            this.setState({ deleteSsoMappingModal: false });
            this.props.getGroups();
            this.props.getAllSSOs();
            this.props.getSsoMappingsGroup(this.props.match.params.id);
        }
    }

    handleSsoDropDown(event) {
        this.setState({ sso_id: event.value });
    }

    handleSsoGlobal() {
        this.setState({ sso_global: !this.state.sso_global })
    }

    handleSsoGroupAttributes(value) {
        this.setState({ sso_group_attributes: value.target.value })
    }

    renderGroupMappings() {
        const columns = [
            {
                type: "text",
                accessor: "sso_type",
                name: "SSO Type",
                filterable: true,
                sortable: true,
                cell: (data) => <div>{data.value == 'oidc' ? 'OpenID' : data.value.toUpperCase()}</div>
            },
            {
                type: "text",
                accessor: "sso_name",
                name: "SSO Name",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "sso_group_attributes",
                name: "SSO group attributes",
                filterable: true,
                sortable: true
            },
            {
                type: "flag",
                accessor: "apply_to_all_users",
                name: "Assign All Users",
                filterable: true,
                sortable: true
            },
        ];

        const actions = [
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "edit":
                    let sso_type = null
                    let sso_id = null
                    if (item.ldap_id) {
                        sso_type = 'ldap'
                        sso_id = item.ldap_id
                    }
                    if (item.saml_id) {
                        sso_type = 'saml'
                        sso_id = item.saml_id
                    }
                    if (item.oidc_id) {
                        sso_type = 'oidc'
                        sso_id = item.oidc_id
                    }
                    this.updateSsoMappingGroupConfirm(
                        item.sso_group_id,
                        sso_id,
                        sso_type,
                        item.sso_group_attributes,
                        item.apply_to_all_users
                    );
                    break;

                case "delete":
                    this.deleteSsoMappingGroupConfirm(item.sso_group_id);
                    break;
            }
        }

        return (
            <div>
                <DataTable
                    id="group-sso-mappings"
                    data={this.props.groupMappings}
                    columns={columns}
                    actions={actions}
                    onAction={onAction}
                />
            </div>
        );
    }

    handleBlur(e) {
        this.setState({ settingValue: e.target.value });
    }

    handleBlur2(e) {
        this.setState({ newValue: e.target.value });
    }

    async fetchUserAdmins(page, filter = null) {
        const data = {
            page,
            page_size: 5,
            filters: [{
                id: "username",
                value: filter
            }],
            sort_by: "username",
            sort_direction: "asc"
        }

        const { users } = await api.post('admin/get_users', data);

        const allUsers = _(this.state.adminUsers || [])
            .concat(users || [])
            .uniqBy("user_id")
            .value();

        this.setState({
            adminUsers: allUsers,
            adminUsersPage: page,
            adminUsersFilter: filter
        });
    }

    render() {
        const { settings, handleSubmit, ssos } = this.props;
        const { currentGroup, value_type, description } = this.state;
        const { users } = this.props;
        const { images } = this.props;
        const { groupMappings } = this.props;
        const usage_interval_options = [
            { value: "daily", label: 'Daily' },
            { value: "weekly", label: 'Weekly' },
            { value: "monthly", label: 'Monthly' },
            { value: "total", label: 'Total' },

        ];
        const usage_type_options = [
            { value: "per_user", label: 'Per User' },
            { value: "per_group", label: 'Per Group' }
        ];

        let optSettings = this.props.allSettings.slice();
        if (this.props.allSettings.length > 0) {
            for (var j = 0; j < this.props.settings.length; j++) {
                for (var i = 0; i < optSettings.length; i++) {
                    if (this.props.settings[j].name === optSettings[i].name) {
                        optSettings.splice(i, 1);
                        break;
                    }
                }
            }
        }

        const loadMoreAdminUsers = () => {
            this.fetchUserAdmins(this.state.adminUsersPage + 1, this.state.adminUsersFilter);
        }

        const updateAdminUsersFilter = (value) => {
            if (value) {
                this.setState({
                    adminUsers: []
                });

                this.fetchUserAdmins(0, value);
            }
        }

        let ssoOptions = [];
        ssos.map(sso => {
            let sso_type = null
            if (sso.sso_type == 'oidc') {
                sso_type = 'OpenID';
            }
            else {
                sso_type = sso.sso_type.toUpperCase()
            }
            ssoOptions.push({ label: sso_type + " - " + sso.name, value: sso.id.replaceAll('-', '') });
        });

        ssoOptions.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        const unaddedImages = _(this.props.allimages)
            .reject(image => _.some(images, (groupImage) => groupImage.image_id === image.image_id))
            .orderBy(image => image.friendly_name.toLowerCase(), "asc")
            .value();

        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes} />
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <div className="title-head">
                                    <strong>Group Properties</strong></div>
                                {currentGroup ? <Link className="pull-right" to={{ pathname: `/updategroup/${currentGroup.group_id}` }}>
                                    <Button className="reset-btn" size="sm" color="primary"> Edit Group </Button> </Link> : " "}
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div className="profile-table">
                                            {currentGroup ?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>Name</h4></td><td>{currentGroup.name ? currentGroup.name : "-"}</td></tr>
                                                        <tr><td><h4>Description</h4></td><td>{currentGroup.description ? currentGroup.description : "-"}</td></tr>
                                                        <tr><td><h4>Priority</h4></td><td>{currentGroup.priority ? currentGroup.priority : "-"}</td></tr>
                                                        <tr><td><h4>Is System </h4></td><td><img src={currentGroup.is_system ? iconYes : iconNo} alt="yesNoIcon" /></td></tr>
                                                    </tbody>
                                                </Table> : " "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardHeader>
                                <div className="title-head">
                                    <strong> Users in Groups  </strong></div>
                                <button className="pull-right adduser-btn" size="sm" color="dark" onClick={this.openUserAddModal}>
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                    Add User
                                </button>
                            </CardHeader>
                            <CardBody className="p-0">
                                <Row>
                                    <Col xs="12">
                                        {users && users.length > 0 ?
                                            <div>{this.renderUsers(users)}</div>
                                            : <Card className="p-3"><CardBody>No Users belong to this group </CardBody></Card>}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardHeader>
                                <div className="title-head">
                                    <strong> Group Settings </strong></div>
                                <button className="pull-right adduser-btn" size="sm" color="dark" onClick={this.openSettingAddModal}>
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                    Add Settings </button>
                            </CardHeader>
                            <CardBody className="p-0">
                                <Row>
                                    <Col xs="12">
                                        <Row>
                                            <Col xs="12">
                                                <p className="viewGroupHeadingP">
                                                    Use group settings to change different properties of a Kasm based on a user&apos;s group membership. The group with the lowest priority number takes affect.
                                                </p>
                                            </Col>
                                        </Row>
                                        {settings && settings.length > 0 ?
                                            <div>{this.renderSettings(settings)}</div>
                                            : <Card className="p-3"><CardBody>No Settings Found!</CardBody></Card>}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>


                        <Card>
                            <CardHeader>
                                <div className="title-head">
                                    <strong> Group Workspaces </strong></div>
                                <button className="pull-right adduser-btn" size="sm" color="dark" onClick={this.openImageAddModal}>
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                    Add Workspaces
                                </button>
                            </CardHeader>
                            <CardBody className="p-0">
                                <Row>
                                    <Col xs="12">
                                        <Row>
                                            <Col xs="12">
                                                <p className="viewGroupHeadingP">
                                                    Select what Workspaces this group has access to. By default all Workspaces are added to the &apos;Users&apos; group, which all users are a member of.
                                                </p>
                                            </Col>
                                        </Row>
                                        {images && images.length > 0 ? <div>{this.renderImages(images)}</div>
                                            : <Card className="p-3"><CardBody>No Workspaces Found</CardBody></Card>}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardHeader>
                                <div className="title-head">
                                    <strong> SSO Group Mappings </strong></div>
                                <button className="pull-right adduser-btn" size="sm" color="dark"
                                    onClick={this.openSsoMappingAddModal}>
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                    Add SSO Mapping
                                </button>
                            </CardHeader>
                            <CardBody className="p-0">
                                <Row>
                                    <Col xs="12">
                                        <Row>
                                            <Col xs="12">
                                                <p className="viewGroupHeadingP">
                                                    Configured SSO groups (i.e. LDAP, SAML, OIDC) to map Kasm users to Kasm Workspaces groups automatically)
                                                </p>
                                            </Col>
                                        </Row>
                                        {groupMappings && groupMappings.length > 0 ?
                                            <div>{this.renderGroupMappings(groupMappings)}</div>
                                            : <Card className="p-3"><CardBody>No SSO group mappings</CardBody></Card>}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>


                        <Modal isOpen={this.state.imageModal} toggle={this.deleteImgConfirm} centered={true} className="user-modal">
                            <ModalHeader toggle={this.deleteImgConfirm}>Are you sure you want to delete this Workspace?
                            </ModalHeader>
                            <ModalFooter>
                                <Button onClick={this.deleteImgConfirm} size="sm"
                                    className="cancel-button"
                                    color="basic">Close</Button>
                                <Button onClick={this.deleteImageGroup}
                                    className="delete-button"
                                    size="sm" color="danger"> Delete</Button>
                            </ModalFooter>
                        </Modal>


                        <Modal isOpen={this.state.settingModal} toggle={this.deleteSetConfirm} centered={true} className="user-modal">
                            <ModalHeader toggle={this.deleteSetConfirm}>Are you sure you want delete this setting?
                            </ModalHeader>
                            <ModalFooter>
                                <Button onClick={this.deleteSetConfirm} size="sm"
                                    className="cancel-button"
                                    color="basic"> Close</Button>
                                <Button onClick={this.deleteSettingGroup} size="sm"
                                    className="delete-button"
                                    color="danger">Delete</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={this.state.updateSettingModal} toggle={this.openUpdateSettingModal} centered={true} className="user-modal">
                            <ModalHeader toggle={this.openUpdateSettingModal}>Update Setting
                            </ModalHeader>
                            <Form onSubmit={handleSubmit(this.updateSettingsGroup)}>
                                <ModalBody>
                                    {this.state.updateName}
                                    <div style={{ "marginTop": "10px" }}>
                                        {this.state.updateType === undefined ? ("") : (<Label className="requiredasterisk">Value {this.state.updateType === "bool" ? ("") : (<span>(Type: {this.state.updateType})  </span>)}</Label>)}
                                        {(this.state.updateType === "bool") ?
                                            (<div>
                                                <FormGroup check> <Label check> <Input type="radio" name="radio1" checked={this.state.radio1 && this.state.radio1 === "True" ? true : false} value={"True"} onChange={this.handleRadio} />{" "} True </Label> </FormGroup>
                                                <FormGroup check> <Label check> <Input type="radio" name="radio1" checked={this.state.radio1 && this.state.radio1 === "False" ? true : false} value={"False"} onChange={this.handleRadio} />{" "} False </Label> </FormGroup>
                                            </div>) :
                                            (" ")
                                        }
                                        {(this.state.updateType === "int") ?
                                            (<Field name="inputValue" type="text" value={this.state.newValue} component={renderField} validate={[required, number]} placeholder={this.state.updateValue} onChange={this.handleBlur2} />)
                                            : ("")
                                        }
                                        {(this.state.updateType === "float") ?
                                            (<Field name="inputValue" type="text" value={this.state.newValue} component={renderField} validate={[required, positive_float]} placeholder={this.state.updateValue} onChange={this.handleBlur2} />)
                                            : ("")
                                        }
                                        {(this.state.updateType === "usage_limit") ?
                                            (<div>
                                                <div className="group_form_label">Type: </div>
                                                <Select
                                                    id="update-usage-type-select"
                                                    autoFocus
                                                    clearable={false}
                                                    value={this.state.updateUsageType}
                                                    options={usage_type_options}
                                                    name="usage_limit_type"
                                                    onChange={this.handleUpdateUsageType}
                                                />
                                                <div className="group_form_label">Interval: </div>
                                                <Select
                                                    id="update-usage-interval-select"
                                                    autoFocus
                                                    clearable={false}
                                                    value={this.state.updateUsageInterval}
                                                    options={usage_interval_options}
                                                    name="usage_limit_interval"
                                                    onChange={this.handleUpdateUsageInterval}
                                                />
                                                <div className="group_form_label">Hours: </div>
                                                <Field
                                                    name="update_usage_hours"
                                                    type="text"
                                                    value={this.state.updateUsageHours}
                                                    component={renderField}
                                                    validate={[required, positive_float]}
                                                    onChange={this.handleUpdateUsageHours}
                                                />
                                            </div>
                                            )
                                            : ("")
                                        }
                                        {(this.state.updateType === "json") ?
                                            (<Field name="inputValue" type="text" value={this.state.newValue} component={renderField} validate={[required, json]} placeholder={this.state.updateValue} onChange={this.handleBlur2} />)
                                            : ("")
                                        }
                                        {(this.state.updateType === "string") ?
                                            (<Field name="inputValue" type="text" value={this.state.newValue} component={renderField} validate={[required]} placeholder={this.state.updateValue} onChange={this.handleBlur2} />)
                                            : ("")
                                        }
                                        {(this.state.updateType === "image") ?
                                            (<Select
                                                id="state-select"
                                                autoFocus
                                                value={this.state.newValue}
                                                placeholder={this.props.images.find(element => element.image_id === this.state.updateValue)
                                                    ? this.props.images.find(element => element.image_id === this.state.updateValue).image_friendly_name : "No Workspace Selected"}
                                                options={this.props.images.sort((a, b) => (a.image_friendly_name.toLowerCase() > b.image_friendly_name.toLowerCase()) ? 1 : -1)}
                                                valueKey="image_id"
                                                labelKey="image_friendly_name"
                                                name="selected-state"
                                                onChange={this.updateDefaultImageDropDown}
                                            />)
                                            : ("")
                                        }
                                        {(this.state.updateType === "filter_policy") ?
                                            (
                                                <Select
                                                    id="state-select"
                                                    autoFocus
                                                    value={this.state.newValue}
                                                    placeholder={this.props.filters.find(element => element.filter_policy_id === this.state.updateValue)
                                                        ? this.props.filters.find(element => element.filter_policy_id === this.state.updateValue).filter_policy_name : "No Policy Selected"}
                                                    options={this.props.filters.sort((a, b) => (a.filter_policy_name.toLowerCase() > b.filter_policy_name.toLowerCase()) ? 1 : -1)}
                                                    valueKey="filter_policy_id"
                                                    labelKey="filter_policy_name"
                                                    name="selected-state"
                                                    onChange={this.updateDefaultFilterDropDown}
                                                />)
                                            : ("")
                                        }
                                    </div>

                                </ModalBody>
                                <ModalFooter>
                                    <Button onClick={this.openUpdateSettingModal}
                                        className="cancel-button"
                                        size="sm" color="basic"> Close</Button>
                                    <Button type="submit"
                                        className="submit-button"
                                        size="sm" color="primary">  Update</Button>
                                </ModalFooter>
                            </Form>
                        </Modal>


                        <Modal isOpen={this.state.userModal} toggle={this.deleteConfirm} centered={true} className="user-modal">
                            <ModalHeader toggle={this.deleteConfirm}>Are you sure you want to delete this user?
                            </ModalHeader>
                            <ModalFooter>
                                <Button onClick={this.toggle}
                                    className="cancel-button"
                                    size="sm" color="basic"> Close</Button>
                                <Button onClick={this.deleteUserGroup}
                                    className="delete-button"
                                    size="sm" color="danger">Delete</Button>
                            </ModalFooter>
                        </Modal>


                        <Modal isOpen={this.state.addSettingModal} toggle={this.toggleSetting} centered={true} className="user-modal">
                            <Form onSubmit={handleSubmit(this.addSettingsGroup)}>
                                <ModalHeader toggle={this.toggleSetting}>Add Setting</ModalHeader>
                                <ModalBody>
                                    <Select
                                        id="state-select"
                                        autoFocus
                                        value={this.state.addGroupSettingId}
                                        options={optSettings.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)}
                                        valueKey="group_setting_id"
                                        labelKey="name"
                                        name="selected-state"
                                        onChange={this.handleSettingDropDown}
                                    />
                                    <br />
                                    {description ? (
                                        <Card>
                                            <CardBody>
                                                {description}
                                            </CardBody>
                                        </Card>
                                    ) : ""}
                                    <div style={{ "marginTop": "10px" }}>
                                        {value_type === undefined ? ("") : (<Label className="requiredasterisk">Value {value_type === "bool" ? ("") : (<span>(Type: {value_type})  </span>)}</Label>)}
                                        {(value_type === "bool") ?
                                            (<div>
                                                <FormGroup check> <Label check> <Input type="radio" name="radio1" checked={this.state.radio1 && this.state.radio1 === "True" ? true : false} value={"True"} onChange={this.handleRadio} />{" "} True </Label> </FormGroup>
                                                <FormGroup check> <Label check> <Input type="radio" name="radio1" checked={this.state.radio1 && this.state.radio1 === "False" ? true : false} value={"False"} onChange={this.handleRadio} />{" "} False </Label> </FormGroup>
                                            </div>) :
                                            (" ")
                                        }
                                        {(value_type === "int") ?
                                            (<Field name="inputValue" type="text" value={this.state.settingValue} component={renderField} validate={[required, number]} placeholder={value_type} onChange={this.handleBlur} />)
                                            : ("")
                                        }
                                        {(value_type === "float") ?
                                            (<Field name="inputValue" type="text" value={this.state.settingValue} component={renderField} validate={[required, positive_float]} placeholder={value_type} onChange={this.handleBlur} />)
                                            : ("")
                                        }
                                        {(value_type === "usage_limit") ?
                                            (<div>
                                                <div className="group_form_label">Type: </div>
                                                <Select
                                                    id="update-usage-type-select"
                                                    autoFocus
                                                    clearable={false}
                                                    value={this.state.createUsageType}
                                                    options={usage_type_options}
                                                    name="usage_limit_type"
                                                    onChange={this.handleCreateUsageType}
                                                />
                                                <div className="group_form_label">Interval: </div>
                                                <Select
                                                    id="update-usage-interval-select"
                                                    autoFocus
                                                    clearable={false}
                                                    value={this.state.createUsageInterval}
                                                    options={usage_interval_options}
                                                    name="usage_limit_interval"
                                                    onChange={this.handleCreateUsageInterval}
                                                />
                                                <div className="group_form_label">Hours: </div>
                                                <Field
                                                    name="update_usage_hours"
                                                    type="text"
                                                    value={this.state.createUsageHours}
                                                    component={renderField}
                                                    validate={[required, positive_float]}
                                                    onChange={this.handleCreateUsageHours}
                                                />
                                            </div>
                                            )
                                            : ("")
                                        }
                                        {(value_type === "json") ?
                                            (<Field name="inputValue" type="text" value={this.state.settingValue} component={renderField} validate={[required, json]} placeholder={value_type} onChange={this.handleBlur} />)
                                            : ("")
                                        }
                                        {(value_type === "string") ?
                                            (<Field name="inputValue" type="text" value={this.state.settingValue} component={renderField} validate={[required]} placeholder={value_type} onChange={this.handleBlur} />)
                                            : ("")
                                        }
                                        {(value_type === "image") ?
                                            (<Select
                                                id="state-select"
                                                autoFocus
                                                value={this.state.settingValue}
                                                options={this.props.images.sort((a, b) => (a.image_friendly_name.toLowerCase() > b.image_friendly_name.toLowerCase()) ? 1 : -1)}
                                                valueKey="image_id"
                                                labelKey="image_friendly_name"
                                                name="selected-state"
                                                onChange={this.handleDefaultImageDropDown}
                                            />)
                                            : ("")
                                        }
                                        {(value_type === "filter_policy") ?
                                            (
                                                <Select
                                                    id="state-select"
                                                    autoFocus
                                                    value={this.state.settingValue}
                                                    options={this.props.filters.sort((a, b) => (a.filter_policy_name.toLowerCase() > b.filter_policy_name.toLowerCase()) ? 1 : -1)}
                                                    valueKey="filter_policy_id"
                                                    labelKey="filter_policy_name"
                                                    name="selected-state"
                                                    onChange={this.handleDefaultFilterDropDown}
                                                />)
                                            : ("")
                                        }

                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button onClick={this.toggleSetting}
                                        className="cancel-button"
                                        size="sm" color="basic"> Cancel</Button>
                                    <Button type="submit" size="sm"
                                        className="submit-button"
                                        color="primary"> Add</Button>
                                </ModalFooter>
                            </Form>
                        </Modal>


                        <Modal isOpen={this.state.addImageModal} toggle={this.toggleImage} centered={true} className="user-modal">
                            <ModalHeader toggle={this.toggleImage}>Add Workspace</ModalHeader>
                            <ModalBody>
                                <Select
                                    id="state-select"
                                    autoFocus
                                    value={this.state.addImageId}
                                    options={unaddedImages}
                                    valueKey="image_id"
                                    labelKey="friendly_name"
                                    name="selected-state"
                                    onChange={this.handleImageDropDown}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button onClick={this.toggleImage} size="sm"
                                    className="cancel-button"
                                    color="basic"> Cancel</Button>
                                <Button onClick={this.addImagesGroup} size="sm"
                                    className="submit-button"
                                    color="primary">Add</Button>
                            </ModalFooter>
                        </Modal>


                        <Modal isOpen={this.state.addUserModal} toggle={this.toggleModal2} centered={true} className="user-modal">
                            <ModalHeader toggle={this.toggleModal2}>Add Users</ModalHeader>
                            <ModalBody>
                                <Select
                                    id="state-select"
                                    autoFocus
                                    value={this.state.addUserId}
                                    options={this.state.adminUsers}
                                    valueKey="user_id"
                                    labelKey="username"
                                    name="selected-state"
                                    onChange={this.handleUserDropDown}
                                    onInputChange={updateAdminUsersFilter}
                                    onMenuScrollToBottom={loadMoreAdminUsers}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button onClick={this.toggleModal2} size="sm"
                                    className="cancel-button"
                                    color="basic"> Cancel</Button>
                                <Button onClick={this.addUserToGroup} size="sm"
                                    className="submit-button"
                                    color="primary">  Add</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={this.state.updateSsoMappingModal} toggle={this.openUpdateSsoMappingModal} centered={true} className="user-modal">
                            <ModalHeader toggle={this.openUpdateSsoMappingModal}>Update SSO Group Mapping
                            </ModalHeader>
                            <Form onSubmit={handleSubmit(this.updateSsoMappingGroup)}>
                                <ModalBody>
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <Label>SSO Provider</Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Select id="sso_id"
                                                    name="sso_id"
                                                    clearable={false}
                                                    autoFocus
                                                    searchable={false}
                                                    placeholder="Please Select a SSO to map to this group"
                                                    value={this.state.sso_id}
                                                    options={ssoOptions}
                                                    validate={required}
                                                    onChange={this.handleSsoDropDown}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <UncontrolledTooltip placement="right" target={"sso_tooltip_component"}>
                                                    All users that authenticate via this SSO provider will be assigned to this group.
                                                </UncontrolledTooltip>
                                                <Label><span id={"sso_tooltip_component"}>Assign All Users</span></Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <input name="sso_global"
                                                    id="sso_global"
                                                    type="checkbox"
                                                    checked={this.state.sso_global}
                                                    value={this.state.sso_global}
                                                    onChange={this.handleSsoGlobal}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <UncontrolledTooltip placement="right" target={"sso_group_tooltip_component"}>
                                                    Only users that match these group attributes defined by the SSO IdP will assigned to this group.
                                                </UncontrolledTooltip>
                                                <Label><span id={"sso_group_tooltip_component"}>Group Attributes</span></Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="relative">
                                                    <Input type="text"
                                                        name="sso_group_attributes"
                                                        id="sso_group_attributes"
                                                        component={renderField}
                                                        value={this.state.sso_group_attributes}
                                                        disabled={this.state.sso_global}
                                                        onChange={this.handleSsoGroupAttributes}
                                                        validate={this.state.sso_global ? null : required}
                                                        size="65"
                                                        placeholder="e.g. admins, users / CN=GroupName,OU=Employees,DC=example,DC=local"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                    <Button onClick={this.openUpdateSsoMappingModal}
                                        className="cancel-button"
                                        size="sm" color="basic"> Close</Button>
                                    <Button type="submit"
                                        className="submit-button"
                                        size="sm" color="primary">  Update</Button>
                                </ModalFooter>
                            </Form>
                        </Modal>

                        <Modal isOpen={this.state.deleteSsoMappingModal} toggle={this.toggleDeleteMappingModal} centered={true} className="user-modal">
                            <ModalHeader toggle={this.toggleDeleteMappingModal}>Are you sure you want to delete this SSO Group Mapping?
                            </ModalHeader>
                            <ModalBody>
                                Note: Users that are already assigned to this group will remain assigned unless otherwise removed.
                            </ModalBody>
                            <ModalFooter>
                                <Button onClick={this.toggleDeleteMappingModal}
                                    className="cancel-button"
                                    size="sm" color="basic"> Close</Button>
                                <Button onClick={this.deleteSsoMappingGroup}
                                    className="delete-button"
                                    size="sm" color="danger">Delete</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={this.state.addSsoMappingModal} toggle={this.toggleMappingModal} centered={true} className="user-modal">
                            <Form onSubmit={handleSubmit(this.addSsoMappingGroup)}>
                                <ModalHeader toggle={this.toggleMappingModal}>Add SSO Group Mapping</ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <Label>SSO Provider</Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Select id="sso_id"
                                                    name="sso_id"
                                                    clearable={false}
                                                    autoFocus
                                                    searchable={false}
                                                    placeholder="Please Select a SSO to map to this group"
                                                    value={this.state.sso_id}
                                                    options={ssoOptions}
                                                    validate={required}
                                                    onChange={this.handleSsoDropDown}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <UncontrolledTooltip placement="right" target={"sso_tooltip_component"}>
                                                    All users that authenticate via this SSO provider will be assigned to this group.
                                                </UncontrolledTooltip>
                                                <Label><span id={"sso_tooltip_component"}>Assign All Users</span></Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <input name="sso_global"
                                                    id="sso_global"
                                                    type="checkbox"
                                                    checked={this.state.sso_global}
                                                    value={this.state.sso_global}
                                                    onChange={this.handleSsoGlobal}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <UncontrolledTooltip placement="right" target={"sso_group_tooltip_component"}>
                                                    Only users that match these group attributes defined by the SSO IdP will assigned to this group.
                                                </UncontrolledTooltip>
                                                <Label><span id={"sso_group_tooltip_component"}>Group Attributes</span></Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="relative">
                                                    <Input type="text"
                                                        name="sso_group_attributes"
                                                        id="sso_group_attributes"
                                                        component={renderField}
                                                        value={this.state.sso_group_attributes}
                                                        disabled={this.state.sso_global}
                                                        onChange={this.handleSsoGroupAttributes}
                                                        validate={this.state.sso_global ? null : required}
                                                        size="65"
                                                        placeholder="e.g. admins, users / CN=GroupName,OU=Employees,DC=example,DC=local"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                    <Button onClick={this.toggleMappingModal} size="sm"
                                        className="cancel-button"
                                        color="basic"> Cancel</Button>
                                    <Button size="sm"
                                        className="submit-button"
                                        color="primary">  Add</Button>
                                </ModalFooter>
                            </Form>
                        </Modal>
                    </Col>
                </Row>
            </div>
        );
    }
}

ViewGroupFormTemplate.propTypes = {
    getGroups: Proptypes.func.isRequired,
    getAllSSOs: Proptypes.func.isRequired,
    getUrlFilterPolicies: Proptypes.func.isRequired,
    addUserToGroup: Proptypes.func.isRequired,
    getSettingsGroup: Proptypes.func.isRequired,
    addSettingsGroup: Proptypes.func.isRequired,
    updateSettingsGroup: Proptypes.func.isRequired,
    removeSettingsGroup: Proptypes.func.isRequired,
    getImagesGroup: Proptypes.func.isRequired,
    getSsoMappingsGroup: Proptypes.func.isRequired,
    addSsoMappingGroup: Proptypes.func.isRequired,
    updateSsoMappingGroup: Proptypes.func.isRequired,
    deleteSsoMappingGroup: Proptypes.func.isRequired,
    addImagesGroup: Proptypes.func.isRequired,
    removeImagesGroup: Proptypes.func.isRequired,
    getUsersGroup: Proptypes.func.isRequired,
    deleteUserFromGroup: Proptypes.func.isRequired,
    getAdminUsers: Proptypes.func.isRequired,
    getImages: Proptypes.func.isRequired,
    match: Proptypes.object,
    errorImageMessage: Proptypes.object,
    removeImagesGroupsError: Proptypes.object,
    addSsoMappingGroupsError: Proptypes.object,
    updateSsoMappingGroupsError: Proptypes.object,
    deleteSsoMappingGroupsError: Proptypes.object,
    getSsoMappingGroupsError: Proptypes.object,
    history: Proptypes.object.isRequired,
    getSettingsId: Proptypes.func.isRequired,
    addSettingsGroupErrorMessage: Proptypes.string,
    addSsoMappingMessage: Proptypes.string,
    updateSsoMappingMessage: Proptypes.string,
    deleteSsoMappingMessage: Proptypes.string,
    getSsoMappingMessage: Proptypes.string,
    updateSettingsGroupErrorMessage: Proptypes.string,
    updateSettingsGroupError: Proptypes.string,
    errorMessageRemove: Proptypes.func,
    deleteSettingFomGroupGroupsError: Proptypes.func,
    errorMessageDeleteUser: Proptypes.func,
    deleteUserFomGroupGroupsError: Proptypes.func,
    addSettingsGroupsError: Proptypes.func,
    errorAddImageMessage: Proptypes.func,
    addImagesGroupsError: Proptypes.func,
    errorMessageAddUser: Proptypes.func,
    addUserToGroupGroupsError: Proptypes.func,
    getAllSSOsError: Proptypes.func,
    groups: Proptypes.array,
    ssos: Proptypes.array,
    images: Proptypes.array,
    filters: Proptypes.array,
    users: Proptypes.array,
    loading: Proptypes.func,
    settings: Proptypes.array,
    allSettings: Proptypes.array,
    groupMappings: Proptypes.array,
    fields: Proptypes.array,
    allusers: Proptypes.array,
    allimages: Proptypes.array,
    initialize: Proptypes.func,
    handleSubmit: Proptypes.func,
    className: Proptypes.func,
};

let ViewGroupFormWithRouter = withRouter(ViewGroupFormTemplate);

let ViewGroupForm = connect(state =>
({
    groups: state.groups.groups || [],
    ssos: state.groups.ssos || [],
    users: state.groups.users || [],
    images: state.groups.images || [],
    filters: state.filter.filters || [],
    settings: state.groups.settings || [],
    allSettings: state.groups.allSettings || [],
    groupMappings: state.groups.groupMappings || [],
    allusers: state.admin.users || [],
    allimages: state.images.images || [],
    addSettingsGroupErrorMessage: state.groups.addSettingsGroupErrorMessage || "",
    updateSettingsGroupErrorMessage: state.groups.updateSettingsGroupErrorMessage || "",
    addSsoMappingMessage: state.groups.addSsoMappingMessage || "",
    updateSsoMappingMessage: state.groups.updateSsoMappingMessage || "",
    deleteSsoMappingMessage: state.groups.deleteSsoMappingMessage || "",
    addSettingsGroupsError: state.groups.addSettingsGroupsError,
    updateSettingsGroupError: state.groups.updateSettingsGroupError,
    addSsoMappingsGroupsError: state.groups.addSsoMappingsGroupsError,
    updateSsoMappingGroupsError: state.groups.updateSsoMappingGroupsError,
    deleteSsoMappingGroupsError: state.groups.deleteSsoMappingGroupsError,
    errorAddImageMessage: state.groups.errorAddImageMessage,
    addImagesGroupsError: state.groups.addImagesGroupsError,
    errorMessageAddUser: state.groups.errorMessageAddUser,
    addUserToGroupGroupsError: state.groups.addUserToGroupGroupsError,
    errorImageMessage: state.groups.errorImageMessage,
    removeImagesGroupsError: state.groups.removeImagesGroupsError,
    errorMessageRemove: state.groups.errorMessageRemove,
    deleteSettingFomGroupGroupsError: state.groups.deleteSettingFomGroupGroupsError,
    errorMessageDeleteUser: state.groups.errorMessageDeleteUser,
    deleteUserFomGroupGroupsError: state.groups.deleteUserFomGroupGroupsError,
    getAllSSOsError: state.groups.getAllSSOsError,
    userPages: { pageSize: state.groups.userPageSize, pageNo: state.groups.userPageNo },
    settingPages: { pageSize: state.groups.settingPageSize, pageNo: state.groups.settingPageNo },
    imagePages: { pageSize: state.groups.imagePageSize, pageNo: state.groups.imagePageNo },
}),
    dispatch =>
    ({
        getGroups: () => dispatch(getGroups()),
        getAllSSOs: () => dispatch(getAllSSOs()),
        addUserToGroup: (data) => dispatch(addUserToGroup(data)),
        getSettingsGroup: (groupId) => dispatch(getSettingsGroup(groupId)),
        addSettingsGroup: (data) => dispatch(addSettingsGroup(data)),
        updateSettingsGroup: (data) => dispatch(updateSettingsGroup(data)),
        removeSettingsGroup: (groupSettingId) => dispatch(removeSettingsGroup(groupSettingId)),
        getImagesGroup: (groupId) => dispatch(getImagesGroup(groupId)),
        getSsoMappingsGroup: (groupId) => dispatch(getSsoMappingsGroup(groupId)),
        addImagesGroup: (data) => dispatch(addImagesGroup(data)),
        removeImagesGroup: (data) => dispatch(removeImagesGroup(data)),
        getUsersGroup: (groupId, page, pageSize) => dispatch(getUsersGroup(groupId, page, pageSize)),
        deleteUserFromGroup: (data) => dispatch(deleteUserFromGroup(data)),
        getAdminUsers: () => dispatch(getAdminUsers()),
        getImages: () => dispatch(getImages()),
        getUrlFilterPolicies: () => dispatch(getUrlFilterPolicies()),
        getSettingsId: () => dispatch(getSettingsId()),
        setUserPageInfo: (data) => dispatch(setGroupUserPageInfo(data)),
        setSettingPageInfo: (data) => dispatch(setGroupSettingPageInfo(data)),
        setImagePageInfo: (data) => dispatch(setGroupImagePageInfo(data)),
        addSsoMappingGroup: (data) => dispatch(addSsoMappingGroup(data)),
        updateSsoMappingGroup: (data) => dispatch(updateSsoMappingGroup(data)),
        deleteSsoMappingGroup: (data) => dispatch(deleteSsoMappingGroup(data)),
    }))(ViewGroupFormWithRouter);

export default reduxForm({
    form: "viewGroupForm"
})(ViewGroupForm);
